import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAssessmentDefinitionStore } from '../store/assessmentDefinitionStore'
import { useAssessmentStore } from '../store/assessmentStore'
import App from '../App'

export default function AssessmentApp() {
  const { slug } = useParams<{ slug: string }>()
  const { loadAssessment, clearAssessment, isLoading, error } = useAssessmentDefinitionStore()
  const resetAssessment = useAssessmentStore((s) => s.resetAssessment)

  useEffect(() => {
    if (!slug) return
    resetAssessment()
    loadAssessment(slug)
    return () => clearAssessment()
  }, [slug, loadAssessment, clearAssessment, resetAssessment])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-assess-bg">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-400">Loading assessment...</p>
        </div>
      </div>
    )
  }

  if (error || !slug) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-assess-bg p-6">
        <div className="glass-card p-8 max-w-md text-center">
          <h1 className="text-xl font-bold text-white mb-2">Assessment unavailable</h1>
          <p className="text-gray-400 text-sm">{error ?? 'Invalid assessment link.'}</p>
        </div>
      </div>
    )
  }

  return <App />
}
